import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Materials", href: "#materials" },
  { label: "Gallery", href: "#gallery" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#120E0B]/80 border-b border-white/5 transition-shadow duration-300 ${
        scrolled ? "shadow-[0_8px_30px_rgba(0,0,0,0.45)]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center">
          <img
            src="/logo-horizontal.png"
            alt="Golden Mile Interiors"
            className="h-11 w-auto"
          />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              href={l.href}
              className="text-sm text-cream-muted hover:text-brass transition-colors tracking-wide"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            data-testid="nav-quote-button"
            className="bg-brass text-espresso-900 text-sm font-semibold px-5 py-2.5 hover:bg-brass-hover transition-colors"
          >
            Request a Quote
          </a>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-cream"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-white/5 bg-[#120E0B]/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-cream-muted hover:text-brass transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            data-testid="nav-mobile-quote-button"
            onClick={() => setOpen(false)}
            className="bg-brass text-espresso-900 text-sm font-semibold px-5 py-3 text-center"
          >
            Request a Quote
          </a>
        </div>
      )}
    </header>
  );
};
